<template>
  <div>
    <v-layout row justify-center>
      <v-dialog v-model="bankUpdateDialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Update Bank Details</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-autocomplete
                    :loading="loading"
                    :items="bankList"
                    item-text="title"
                    label="Bank Name *"
                    v-model="newBankDetails.bank_name"
                    required
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Receiver Name*"
                    required
                    v-model="newBankDetails.receiver_name"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Account No*"
                    required
                    v-model="newBankDetails.account_no"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    label="Bank Routing No*"
                    required
                    v-model="newBankDetails.bank_routing_no"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6>
                  <v-select
                    :items="accountTypes"
                    item-text="title"
                    item-value="id"
                    label="Account Type*"
                    v-model="newBankDetails.account_type"
                    required
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-container>
            <small>*indicates required field</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" flat @click="bankUpdateDialog = false">
              Cancel
            </v-btn>
            <v-btn
              color="success"
              flat
              @click="updateBankDetails"
              :loading="buttonLoading"
              :disabled="
                buttonLoading ||
                !newBankDetails.bank_name ||
                !newBankDetails.receiver_name ||
                !newBankDetails.account_no ||
                !newBankDetails.bank_routing_no ||
                !newBankDetails.account_type
              "
            >
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-divider></v-divider>
    <v-divider></v-divider>
    <v-list class="pt-20 text-left mh100">
      <div class="d-flex justify-space-between align-center">
        <h2 style="margin-left: 15px">Bank Details</h2>
        <v-icon @click="bankUpdateDialog = true">edit</v-icon>
      </div>
      <v-divider></v-divider>
      <br />
      <v-list-tile>
        <v-layout row wrap>
          <v-flex sm4>
            <h5>Bank Name :</h5>
          </v-flex>
          <v-flex sm8>
            <v-list-tile-content>
              {{
                updatedBankDetails && updatedBankDetails.bank_name
                  ? updatedBankDetails.bank_name
                  : "-"
              }}
            </v-list-tile-content>
          </v-flex>
        </v-layout>
      </v-list-tile>
      <v-list-tile>
        <v-layout row wrap>
          <v-flex sm4>
            <h5>Receiver Name :</h5>
          </v-flex>
          <v-flex sm8>
            <v-list-tile-content>
              {{
                updatedBankDetails && updatedBankDetails.receiver_name
                  ? updatedBankDetails.receiver_name
                  : "-"
              }}
            </v-list-tile-content>
          </v-flex>
        </v-layout>
      </v-list-tile>
      <v-list-tile>
        <v-layout row wrap>
          <v-flex sm4>
            <h5>Account No :</h5>
          </v-flex>
          <v-flex sm8>
            <v-list-tile-content>
              {{
                updatedBankDetails && updatedBankDetails.account_no
                  ? updatedBankDetails.account_no
                  : "-"
              }}
            </v-list-tile-content>
          </v-flex>
        </v-layout>
      </v-list-tile>
      <v-list-tile>
        <v-layout row wrap>
          <v-flex sm4>
            <h5>Bank Routing No :</h5>
          </v-flex>
          <v-flex sm8>
            <v-list-tile-content>
              {{
                updatedBankDetails && updatedBankDetails.bank_routing_no
                  ? updatedBankDetails.bank_routing_no
                  : "-"
              }}
            </v-list-tile-content>
          </v-flex>
        </v-layout>
      </v-list-tile>
      <v-list-tile>
        <v-layout row wrap>
          <v-flex sm4>
            <h5>Account Type :</h5>
          </v-flex>
          <v-flex sm8>
            <v-list-tile-content>
              {{
                updatedBankDetails && updatedBankDetails.account_type
                  ? this.accountTypes.find(
                      (type) => type.id == updatedBankDetails.account_type
                    ).title
                  : "-"
              }}
            </v-list-tile-content>
          </v-flex>
        </v-layout>
      </v-list-tile>
      <v-list-tile v-if="updatedBankDetails && !updatedBankDetails.approved_at">
        <v-layout row wrap>
          <v-flex sm4 class="mt-2">
            <h5>Action :</h5>
          </v-flex>
          <v-flex sm8>
            <v-list-tile-content>
              <v-btn
                class="success"
                small
                :loading="buttonLoading"
                @click="approveBankDetails"
              >
                Approve
              </v-btn>
            </v-list-tile-content>
          </v-flex>
        </v-layout>
      </v-list-tile>
      <v-list-tile v-else>
        <v-layout row wrap>
          <v-flex sm4>
            <h5>Status :</h5>
          </v-flex>
          <v-flex sm8>
            <v-list-tile-content>Approved</v-list-tile-content>
          </v-flex>
        </v-layout>
      </v-list-tile>
    </v-list>

    <v-snackbar
      :color="snackbarColor"
      v-model="snackbar"
      bottom
      right
      :timeout="3000"
    >
      {{ snackbarText }}
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
  import HTTP from "@/utils/HTTP";
  import {
    bankListUrl,
    updateBankDetailsUrl,
    approveBankDetailsUrl,
  } from "@/utils/variables";
  export default {
    props: ["bankDetails"],
    data() {
      return {
        loading: true,
        buttonLoading: false,
        bankUpdateDialog: false,
        updatedBankDetails: this.bankDetails,
        newBankDetails: {
          id: this.bankDetails.id || 0,
          user_id: this.bankDetails.user_id || 0,
          bank_name: this.bankDetails.bank_name || "",
          receiver_name: this.bankDetails.receiver_name || "",
          account_no: this.bankDetails.account_no || "",
          bank_routing_no: this.bankDetails.bank_routing_no || "",
          account_type: this.bankDetails.account_type || 0,
        },
        accountTypes: [
          {
            id: 1,
            title: "Saving",
          },
          {
            id: 2,
            title: "Current",
          },
        ],
        bankList: [],
        snackbar: false,
        snackbarText: "",
        snackbarColor: "success",
      };
    },
    async mounted() {
      await this.getAllBanks();
    },
    methods: {
      async getAllBanks() {
        try {
          const { data } = await HTTP().get(bankListUrl);
          this.bankList = data.data;
          this.loading = false;
        } catch (e) {
          //
        }
      },
      async updateBankDetails() {
        this.buttonLoading = true;
        try {
          const { data } = await HTTP().post(
            `${updateBankDetailsUrl}/${this.newBankDetails.id}`,
            this.newBankDetails
          );
          if (data.error == 0) {
            this.updatedBankDetails = { ...data.data };

            this.bankUpdateDialog = false;
            this.snackbarColor = "success";
          } else {
            this.snackbarColor = "error";
          }
          this.snackbarText = data.errorMsg;
          this.snackbar = true;
          this.buttonLoading = false;
        } catch (e) {
          // console.log(e);
        }
      },
      async approveBankDetails() {
        this.buttonLoading = true;
        try {
          const { data } = await HTTP().post(
            `${approveBankDetailsUrl}/${this.newBankDetails.id}`
          );
          if (data.error == 0) {
            this.updatedBankDetails = { ...data.data };
            this.snackbarColor = "success";
          } else {
            this.snackbarColor = "error";
          }
          this.snackbarText = data.errorMsg;
          this.snackbar = true;
          this.buttonLoading = false;
        } catch (e) {
          // console.log(e);
        }
      },
    },
  };
</script>
